import { render, staticRenderFns } from "./InsightCard.vue?vue&type=template&id=dba73dfa&scoped=true"
import script from "./InsightCard.vue?vue&type=script&lang=ts"
export * from "./InsightCard.vue?vue&type=script&lang=ts"
import style0 from "./InsightCard.vue?vue&type=style&index=0&id=dba73dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba73dfa",
  null
  
)

/* custom blocks */
import block0 from "./InsightCard.vue?vue&type=custom&index=0&blockType=InsightCard&%3Ainsight=insight"
if (typeof block0 === 'function') block0(component)

export default component.exports